import { Typography } from 'src/components/UI'
import { HeaderType } from 'src/components/UI/CustomUI/organisms/Table/types'
import { formatTimestamp } from 'src/helpers'

const headers: HeaderType[] = [

    // { id: 'address', label: 'Address' },
    {
        id: 'address',
        label: 'Address',
        custom: true,
        Element: (row: any): JSX.Element => {
            return (
                <Typography variant="h6">{row.address?.fullAddress}</Typography>
            )
        }
    },
    {
        id: 'archived', label: 'Archived', custom: true, Element: (row: any, dispatch): JSX.Element => {
            return (
                <Typography variant="h6">{row.archived ? 'Yes' : 'No'}</Typography>
            )
        }
    },
    {
        id: 'createdOn', label: 'Created On', custom: true, Element: (row: any, dispatch): JSX.Element => {
            return (
                <Typography variant="h6">{row.createdOn ? formatTimestamp(row.createdOn, 'MM/DD/YYYY') : '-'}</Typography>
            )
        }
    }
]

export default headers
